<template>
  <v-dialog :value="dialog" width="500" persistent>
    <v-card
      class="d-flex flex-column align-center justify-space-around"
      :class="$vuetify.breakpoint.xsOnly ? 'pa-6' : 'pa-8'"
    >
      <div class="fw500 mb-6 text-center" style="white-space: pre-line" :class="'f20'">
        {{
          localStorage.translations.pages.common.notifications['send_file-unsupported'] +
          ' (' +
          $formatFileSizeUnits(chatsConfig.files.max_size) +
          ')'
        }}
      </div>
      <BaseTableView :head="tableHead" :sticky="false" class="mb-6 table d-block">
        <tr v-for="(file, fileKey) in chatFileUnsupported" :key="fileKey">
          <td>
            {{ file.errorType?.format ? file.name2 : file.name }}
            <span v-if="file.errorType?.format" class="error--text">
              {{ file.format }}
            </span>
          </td>
          <td :class="{ 'error--text': file.errorType?.size }">
            {{ $formatFileSizeUnits(file.size) }}
          </td>
        </tr>
      </BaseTableView>
      <v-card tile flat width="100%" class="d-flex justify-space-around align-center">
        <v-btn type="button" @click="onClose" class="text-none br15" dark color="#277faf" x-large>
          {{ 'OK' }}
        </v-btn>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'ChatUnsupportedFilesModal',
  data() {
    return { dialog: false }
  },
  watch: {
    chatFileUnsupported() {
      this.$nextTick(function () {
        this.dialog = !!this.chatFileUnsupported.length
      })
    },
  },
  computed: {
    ...mapState('chat', ['chatsConfig']),
    ...mapState('chat/file', ['chatFileUnsupported']),
    tableHead() {
      return [
        {
          text: 'Name',
        },
        { text: 'Size' },
      ]
    },
  },
  methods: {
    ...mapMutations('chat/file', ['SET_chatFileUnsupported']),
    onClose() {
      this.SET_chatFileUnsupported([])
    },
  },
}
</script>
<style lang="scss" scoped>
:deep().table {
  tr {
    td {
      word-break: break-all;
      &:first-of-type {
        width: 100%;
      }
      &:last-of-type {
        min-width: 120px;
      }
    }
  }
}
</style>
